function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRobot(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlnsSvg: "http://svgjs.com/svgjs",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 36 36",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    d: "m27.623 31.833c-6.917 0-11.667 3.583-15 3.583s-10.333-1.916-10.333-17.249 9.417-17.584 13.083-17.584c17.167 0 24.5 31.25 12.25 31.25z",
    fill: "#efefef",
    "data-original": "#efefef",
    style: {},
    className: ""
  }), /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#a4afc1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m28.467 2.967h1v2h-1z",
    transform: "matrix(.707 -.707 .707 .707 5.679 21.645)",
    fill: "#e3e3e3",
    "data-original": "#a4afc1",
    style: {},
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "m32.533 7.033h1v2h-1z",
    transform: "matrix(.707 -.707 .707 .707 3.995 25.711)",
    fill: "#e3e3e3",
    "data-original": "#a4afc1",
    style: {},
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "m31.856 3.467h2v1h-2z",
    transform: "matrix(.707 -.707 .707 .707 6.818 24.395)",
    fill: "#e3e3e3",
    "data-original": "#a4afc1",
    style: {},
    className: ""
  })), /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    d: "m23.25 29.25h-10.5c-1.105 0-2-.895-2-2v-7.5c0-1.105.895-2 2-2h10.5c1.105 0 2 .895 2 2v7.5c0 1.105-.895 2-2 2z",
    fill: "#f3f3f1",
    "data-original": "#f3f3f1",
    style: {}
  }), /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#2fdf84"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 21,
    cy: 22,
    r: 1.25,
    fill: "#e7e7e7",
    "data-original": "#2fdf84",
    style: {},
    className: ""
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 22,
    r: 1.25,
    fill: "#e7e7e7",
    "data-original": "#2fdf84",
    style: {},
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "m23.043 9.417c-.221 0-.435.033-.637.1l-.016.016c.003-.04.022-.075.022-.116 0-1.473-1.128-2.667-2.522-2.667-.895 0-1.677.493-2.125 1.233-.466-.36-1.04-.567-1.658-.567-1.255 0-2.32.86-2.692 2.053-.145-.033-.303-.053-.46-.053-1.217 0-2.207 1.047-2.207 2.333 0 .853.435 1.593 1.078 2h12.344c.643-.407 1.078-1.147 1.078-2 .002-1.286-.988-2.332-2.205-2.332z",
    fill: "#e7e7e7",
    "data-original": "#2fdf84",
    style: {},
    className: ""
  })), /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    d: "m22 22c0-.19.049-.365.125-.526-.2-.425-.625-.724-1.125-.724-.69 0-1.25.56-1.25 1.25s.56 1.25 1.25 1.25c.5 0 .925-.299 1.125-.724-.076-.161-.125-.336-.125-.526z",
    fill: "#d3d3d3",
    "data-original": "#00b871",
    style: {},
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    d: "m16 22c0-.19.049-.365.125-.526-.2-.425-.625-.724-1.125-.724-.69 0-1.25.56-1.25 1.25s.56 1.25 1.25 1.25c.5 0 .925-.299 1.125-.724-.076-.161-.125-.336-.125-.526z",
    fill: "#d3d3d3",
    "data-original": "#00b871",
    style: {},
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    d: "m13 11.75c0-1.287.99-2.333 2.207-2.333.158 0 .315.02.46.053.253-.812.831-1.462 1.568-1.799-.346-.159-.725-.254-1.126-.254-1.255 0-2.32.86-2.692 2.053-.145-.033-.303-.053-.46-.053-1.217 0-2.207 1.047-2.207 2.333 0 .853.435 1.593 1.078 2h2.25c-.643-.407-1.078-1.147-1.078-2z",
    fill: "#d3d3d3",
    "data-original": "#00b871",
    style: {},
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    d: "m13 27.25v-7.5c0-1.105.895-2 2-2h-2.25c-1.105 0-2 .895-2 2v7.5c0 1.105.895 2 2 2h2.25c-1.105 0-2-.895-2-2z",
    fill: "#d9d9d9",
    "data-original": "#d5dbe1",
    style: {},
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    d: "m21 24c-1.103 0-2-.897-2-2s.897-2 2-2 2 .897 2 2-.897 2-2 2zm0-2.5c-.276 0-.5.224-.5.5s.224.5.5.5.5-.224.5-.5-.224-.5-.5-.5z",
    fill: "#000000",
    "data-original": "#000000",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    d: "m15 24c-1.103 0-2-.897-2-2s.897-2 2-2 2 .897 2 2-.897 2-2 2zm0-2.5c-.276 0-.5.224-.5.5s.224.5.5.5.5-.224.5-.5-.224-.5-.5-.5z",
    fill: "#000000",
    "data-original": "#000000",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    d: "m23.25 30h-10.5c-1.517 0-2.75-1.233-2.75-2.75v-7.5c0-1.517 1.233-2.75 2.75-2.75h10.5c1.517 0 2.75 1.233 2.75 2.75v7.5c0 1.517-1.233 2.75-2.75 2.75zm-10.5-11.5c-.689 0-1.25.561-1.25 1.25v7.5c0 .689.561 1.25 1.25 1.25h10.5c.689 0 1.25-.561 1.25-1.25v-7.5c0-.689-.561-1.25-1.25-1.25z",
    fill: "#000000",
    "data-original": "#000000",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    d: "m15.75 25.5h4.5v1.5h-4.5z",
    fill: "#000000",
    "data-original": "#000000",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    d: "m7.75 22.75h3v1.5h-3z",
    fill: "#000000",
    "data-original": "#000000",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    d: "m7 21h1.5v5h-1.5z",
    fill: "#000000",
    "data-original": "#000000",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    d: "m25.25 22.75h3v1.5h-3z",
    fill: "#000000",
    "data-original": "#000000",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    d: "m27.5 21h1.5v5h-1.5z",
    fill: "#000000",
    "data-original": "#000000",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    d: "m24.172 14.5h-12.344c-.142 0-.281-.04-.401-.116-.893-.565-1.427-1.55-1.427-2.634 0-1.692 1.314-3.071 2.935-3.083.61-1.217 1.821-2 3.174-2 .517 0 1.017.112 1.474.329.606-.633 1.429-.996 2.308-.996 1.558 0 2.865 1.142 3.192 2.667 1.612.022 2.917 1.397 2.917 3.083 0 1.084-.534 2.069-1.427 2.634-.12.076-.259.116-.401.116zm-12.103-1.5h11.861c.36-.299.569-.753.569-1.25 0-.873-.653-1.583-1.457-1.583h-.015c-.291.779-1.022 1.333-1.876 1.333h-.75v-1.5h.75c.277 0 .511-.267.511-.583 0-1.057-.795-1.917-1.772-1.917-.598 0-1.153.326-1.483.872-.11.183-.294.31-.504.349-.211.039-.427-.013-.596-.144-.348-.269-.763-.411-1.2-.411-.897 0-1.691.614-1.977 1.527-.117.376-.505.595-.886.507-.915-.212-1.744.575-1.744 1.55 0 .497.209.951.569 1.25z",
    fill: "#000000",
    "data-original": "#000000",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    d: "m15.092 12.167h-.75c-.644 0-1.029-.304-1.239-.559-.624-.758-.427-1.967-.381-2.202l.144-.736 1.472.288-.144.734c-.077.412-.025.883.07.966h.75z",
    fill: "#000000",
    "data-original": "#000000",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    d: "m17.25 14h1.5v3.75h-1.5z",
    fill: "#000000",
    "data-original": "#000000",
    style: {}
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRobot);
export default __webpack_public_path__ + "static/media/robot.9e2cf7c1470e835d6191eaf248d57fca.svg";
export { ForwardRef as ReactComponent };